

// import React from 'react';
// import PropTypes from "prop-types";
// import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import { Typography, CircularProgress } from "@mui/material";
// import Card from "@mui/material/Card";

// // Helper function to get the number of content items for a specific date and platform
// const getDailyContentCounts = (profileData, platform) => {

//   const contentCounts = {};
//   const contentField = platform === "YouTube" ? "videos" : "posts";

//   profileData.forEach(entry => {
//     const date = entry.date;
//     const count = entry[contentField]?.length || 0;
//     contentCounts[date] = count;
//   });


//   return contentCounts;
// };

// function ContentDistributionChart({
//   title,
//   datasets,
//   previousdatasets,
//   isLoading,
// }) {
//   // ⏳ Loader during fetch
//   if (isLoading) {
//     return (
//       <Card>
//         <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="250px">
//           <CircularProgress size={32} thickness={4} color="accent" />
//         </MDBox>
//       </Card>
//     );
//   }

//   if (!datasets) {
//     return (
//       <Card>
//         <MDBox p={3} textAlign="center">
//           <MDTypography variant="body2" color="text">
//             No content data available.
//           </MDTypography>
//         </MDBox>
//       </Card>
//     );
//   }

//   // Generate a dynamic title based on the platforms present
//   const platformSet = new Set(datasets.map((profile) => profile.platform));
//   let derivedTitle = 'Content Count Over Time';
//   if (platformSet.size === 1) {
//     const platform = platformSet.values().next().value;
//     derivedTitle = `${platform} Content Over Time`;
//   }

//   // Ensure all profiles have consistent dates for the x-axis
//   const allDates = new Set();
//   datasets.forEach(profile => {
//     profile.data.forEach(item => {
//       allDates.add(item.date);
//     });
//   });
//   const sortedDates = Array.from(allDates).sort();

//   const allDates_prev = new Set();
//   previousdatasets.forEach(profile => {
//     profile.data.forEach(item => {
//       allDates_prev.add(item.date);
//     });
//   });
//   const sortedDates_prev = Array.from(allDates_prev).sort();

//   // --- Current datasets
//   const currentDataSets = datasets.map(profile => {
//     const dailyCounts = getDailyContentCounts(profile.data, profile.platform);
//     return {
//       label: `${profile.name || profile.label}`,
//       data: sortedDates.map(date => dailyCounts[date] || 0),
//       profileId: profile.profileId,
//       profilePictureUrl: profile.profilePictureUrl || "",
//       platform: profile.platform,
//       metricName: "Content Count",
//     };
//   });

//   // --- Previous datasets
//   const previousDataSets = (previousdatasets || []).map(profile => {
//     const dailyCounts = getDailyContentCounts(profile.data, profile.platform);
//     console.log("Previous dailyCounts for profile", profile.profileId, dailyCounts);
//     return {
//       label: `${profile.name || profile.label}`,
//       data: sortedDates_prev.map(date => dailyCounts[date] || 0),
//       profileId: profile.profileId,
//       profilePictureUrl: profile.profilePictureUrl || "",
//       platform: profile.platform,
//       metricName: "Content Count (Previous)",
//     };
//   });


//   // Construct the final chart data
//   const chartData = {
//     labels: sortedDates,
//     datasets: currentDataSets,
//     previousdatasets: previousDataSets,
//   };

//   const tooltipContent = (
//     <div style={{ maxWidth: "350px", textAlign: "left" }}>
//       <Typography variant="body2" gutterBottom>
//         <strong>Description:</strong>
//       </Typography>
//       <Typography variant="caption" display="block" gutterBottom>
//         This chart shows the daily count of new content (posts, videos, etc.) published by a profile.
//       </Typography>

//       <Typography variant="body2" gutterBottom>
//         <strong>How to read the chart:</strong>
//       </Typography>
//       <Typography variant="caption" display="block" gutterBottom>
//         - <strong>Peaks</strong>: Days with high content output. <br />
//         - <strong>Dips</strong>: Days with low or no content output. <br />
//       </Typography>

//       <Typography variant="body2" gutterBottom>
//         <strong>Insights you can gain:</strong>
//       </Typography>
//       <Typography variant="caption" display="block">
//         - Track content publishing frequency and consistency. <br />
//         - Identify patterns in content creation, such as daily or weekly cycles. <br />
//         - Correlate content output with engagement metrics to find optimal posting schedules.
//       </Typography>
//     </div>
//   );

//   return (
//     <Card>
//       <DefaultLineChart
//         title={title || derivedTitle}
//         description={tooltipContent}
//         height="19.125rem"
//         chart={chartData}
//         aggregate={true}
//       />
//     </Card>
//   );
// }

// // 🛡️ PropTypes Validation
// ContentDistributionChart.propTypes = {
//   title: PropTypes.string,
//   datasets: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string,
//       label: PropTypes.string,
//       platform: PropTypes.string.isRequired,
//       profilePictureUrl: PropTypes.string,
//       data: PropTypes.arrayOf(
//         PropTypes.shape({
//           date: PropTypes.string.isRequired,
//           posts: PropTypes.array,
//           videos: PropTypes.array,
//         })
//       ).isRequired,
//     })
//   ).isRequired,
//   previousdatasets: PropTypes.array, // 👈 added this
//   isLoading: PropTypes.bool,
// };

// export default ContentDistributionChart;


// ############################################################

import React, { useState } from "react";
import PropTypes from "prop-types";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Typography, CircularProgress } from "@mui/material";
import Card from "@mui/material/Card";
import EntitiesPopup from "layouts/components/EntitiesPopup"; // ✅ Added popup import

// Helper function to get number of content items for a specific date/platform
const getDailyContentCounts = (profileData, platform) => {
  const contentCounts = {};
  const contentField = platform === "YouTube" ? "videos" : "posts";

  profileData.forEach((entry) => {
    const date = entry.date;
    const count = entry[contentField]?.length || 0;
    contentCounts[date] = count;
  });

  return contentCounts;
};

// ... (previous imports)

function ContentDistributionChart({
  title,
  datasets,
  previousdatasets,
  isLoading,
  entitlements, // ✅ Added prop
  viewMode, // ✅ NEW
  onViewModeChange // ✅ NEW
}) {
  // ✅ Popup state
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupDate, setPopupDate] = useState(null);

  const handlePointClick = (date) => {
    setPopupDate(date);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupDate(null);
  };

  // ⏳ Loader during fetch
  if (isLoading) {
    return (
      <Card>
        <MDBox p={3} display="flex" justifyContent="center" alignItems="center" height="250px">
          <CircularProgress size={32} thickness={4} color="accent" />
        </MDBox>
      </Card>
    );
  }

  if (!datasets) {
    return (
      <Card>
        <MDBox p={3} textAlign="center">
          <MDTypography variant="body2" color="text">
            No data available.
          </MDTypography>
        </MDBox>
      </Card>
    );
  }

  // --- Dynamic title based on platforms
  const platformSet = new Set(datasets.map((profile) => profile.platform));
  let derivedTitle = "Content Count Over Time";
  if (platformSet.size === 1) {
    const platform = platformSet.values().next().value;
    derivedTitle = `${platform} Content Over Time`;
  }

  // --- Collect all unique dates for x-axis alignment
  const allDates = new Set();
  datasets.forEach((profile) => {
    profile.data.forEach((item) => {
      allDates.add(item.date);
    });
  });
  const sortedDates = Array.from(allDates).sort();

  const allDates_prev = new Set();
  (previousdatasets || []).forEach((profile) => {
    profile.data.forEach((item) => {
      allDates_prev.add(item.date);
    });
  });
  const sortedDates_prev = Array.from(allDates_prev).sort();

  // --- Current datasets
  const currentDataSets = datasets.map((profile) => {
    // 🔍 DEBUG LOG
    // console.log("ContentDistributionChart: Processing profile", profile.name, "Picture:", profile.profilePictureUrl);

    const dailyCounts = getDailyContentCounts(profile.data, profile.platform);
    return {
      label: `${profile.name || profile.label}`,
      data: sortedDates.map((date) => dailyCounts[date] || 0),
      profileId: profile.profileId,
      profilePictureUrl: profile.profilePictureUrl || profile.profile_picture_url || "",
      platform: profile.platform,
      metricName: "Content Count",
    };
  });

  // --- Previous datasets
  const previousDataSets = (previousdatasets || []).map((profile) => {
    const dailyCounts = getDailyContentCounts(profile.data, profile.platform);
    return {
      label: `${profile.name || profile.label}`,
      data: sortedDates_prev.map((date) => dailyCounts[date] || 0),
      profileId: profile.profileId,
      profilePictureUrl: profile.profilePictureUrl || profile.profile_picture_url || "",
      platform: profile.platform,
      metricName: "Content Count (Previous)",
    };
  });

  // --- Chart Data
  const chartData = {
    labels: sortedDates,
    datasets: currentDataSets,
    previousdatasets: previousDataSets,
  };

  // --- Tooltip
  const tooltipContent = (
    <div style={{ maxWidth: "350px", textAlign: "left" }}>
      <Typography variant="body2" gutterBottom>
        <strong>Description:</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        This chart shows the daily count of new content (posts, videos, etc.) published by a profile.
      </Typography>

      <Typography variant="body2" gutterBottom>
        <strong>How to read the chart:</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        - <strong>Peaks</strong>: Days with high content output. <br />
        - <strong>Dips</strong>: Days with low or no content output. <br />
      </Typography>

      <Typography variant="body2" gutterBottom>
        <strong>Insights you can gain:</strong>
      </Typography>
      <Typography variant="caption" display="block">
        - Track content publishing frequency and consistency. <br />
        - Identify patterns in content creation, such as daily or weekly cycles. <br />
        - Correlate content output with engagement metrics to find optimal posting schedules.
      </Typography>
    </div>
  );

  // --- Render chart + popup
  return (
    <>
      <Card>
        <DefaultLineChart
          title={title || derivedTitle}
          description={tooltipContent}
          height="19.125rem"
          chart={chartData}
          aggregate={true}
          onPointClick={handlePointClick}
          rawData={datasets}
          entitlements={entitlements}
          viewMode={viewMode} // ✅ Pass down CORRECT PROP NAME
          onViewModeChange={onViewModeChange} // ✅ Pass down
        />
      </Card>

      {isPopupOpen && (
        <EntitiesPopup
          isModalOpen={isPopupOpen}
          onClose={handlePopupClose}
          datasets={datasets}
          date={popupDate}
        />
      )}
    </>
  );
}

// 🛡️ PropTypes Validation
ContentDistributionChart.propTypes = {
  // ... (previous propTypes)
  previousdatasets: PropTypes.array,
  isLoading: PropTypes.bool,
  entitlements: PropTypes.object,
  viewMode: PropTypes.string, // ✅ NEW
  onViewModeChange: PropTypes.func, // ✅ NEW
};

export default ContentDistributionChart;
